import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Box, styled, Switch, InputAdornment, MenuItem } from "@mui/material";
import { useEffect } from "react";
import { useQuery } from "react-query";
import axiosInstance from "../../../utils/AxiosInstance";
import { useAuthHeader } from "react-auth-kit";
import { services } from "../../ServiceComponents";

const EditableSelectInput = ({
  inputId,
  propsInitialValue,
  editMode,
  queryKey,
  inputMode,
  type,
  setParentValue,
  selectAllowEmpty = true,
}) => {
  // basic editable component stuff
  const [value, setValue] = useState(
    propsInitialValue !== null ? propsInitialValue : ""
  );
  const [initialValue, setInitialValue] = useState(
    propsInitialValue !== null ? propsInitialValue : ""
  );

  // has been focused in edit mode
  const [touched, setTouched] = useState(false);

  // select-specific
  const [displayData, setDisplayData] = useState();
  const authHeader = useAuthHeader();

  // callback from the parent
  const handleInputChange = (e) => {
    setValue(e.target.value);
  };

  const handleBlur = () => {
    if (value !== initialValue) {
      setTouched(true);
      setParentValue(inputId, value);
    }
  };

  const query = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      let res;

      if (queryKey !== null) {
        res = await axiosInstance.get(`/${queryKey.join("/")}`, {
          headers: { Authorization: authHeader() },
        });
      }

      let data = queryKey === null ? null : res.data;

      switch (type) {
        case "patients":
          setDisplayData(data.patients);
          break;
        case "doctors":
          setDisplayData(data.doctors);
          break;
        case "devices":
          setDisplayData(data.devices);
          break;
        case "organizations":
          setDisplayData(data.organizations);
          break;
        case "kits":
          setDisplayData(data.kits ?? []);
          break;
        case "gender":
          setDisplayData([
            { id: "M", name: "M" },
            { id: "F", name: "F" },
          ]);
          break;
        case "position":
          setDisplayData([
            { id: "SX", name: "SX" },
            { id: "DX", name: "DX" },
          ]);
          break;
        case "delivery":
          setDisplayData([
            { id: 1, name: "Ritiro in studio" },
            { id: 2, name: "Consegna a casa" },
          ]);
          break;
        case "services":
          setDisplayData(
            services.map((service) => {
              return { id: service.id, name: service.label };
            })
          );
          break;
      }

      return data;
    },
    enabled: queryKey !== undefined,
  });
  if (query.isError) console.log("Error downloading query.");

  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs>
        {displayData !== undefined && (
          <TextField
            select
            fullWidth
            margin="dense"
            defaultValue={""}
            value={value}
            onChange={handleInputChange}
            variant="standard"
            onBlur={handleBlur}
            disabled={!editMode}
          >
            {(selectAllowEmpty
              ? displayData.concat({ id: null, name: "Empty" })
              : displayData
            ).map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.id === null
                  ? "\u00A0"
                  : type === "patients" || type === "doctors"
                  ? `${option.first_name} ${option.last_name}`
                  : option.name}
              </MenuItem>
            ))}
          </TextField>
        )}
      </Grid>
    </Grid>
  );
};

export default EditableSelectInput;
